import { ref, withParams } from 'vuelidate/lib/validators/common';
import { helpers } from 'vuelidate/lib/validators';

export default maxFileSize => withParams(
  { type: 'maxFileSize', eq: maxFileSize, maxFileSize },
  (value, parentVm) => {
    if (!helpers.req(value) || (value && value.size <= maxFileSize)) {
      return true;
    }

    return false;
  },
);
